<template>
    <div class="w-100">
        <vc-calendar
            ref="vc"
            class="custom-calendar w-100 shadow"
            :masks="masks"
            :attributes="attributes"
            disable-page-swipe
            is-expanded
            @transition-end="getItems"
        >
            <template #day-content="{ day, attributes }">
                <div class="flex flex-col h-full z-10 overflow-hidden">
                    <span class="day-label text-sm text-gray-900">{{
                        day.day
                    }}</span>
                    <div class="flex-grow overflow-y-auto overflow-x-auto">
                        <b-link
                            v-for="attr in attributes"
                            :key="attr.key"
                            @click="goTo(attr.customData)"
                        >
                            <p
                                class="vc-item leading-tight rounded-sm p-1 mb-1"
                                :class="attr.customData.class"
                            >
                                <i :class="attr.customData.icon"></i>
                                {{
                                    attr.customData.action_title +
                                    ' (' +
                                    attr.customData.assigned_to +
                                    ')'
                                }}
                            </p>
                        </b-link>
                    </div>
                </div>
            </template>
        </vc-calendar>
    </div>
</template>

<script>
export default {
    name: 'ClientDeadlinesCalendar',

    props: {
        client: null,
    },

    data() {
        const month = new Date().getMonth()
        const year = new Date().getFullYear()
        return {
            displayedMonth: month,
            displayedYear: year,

            masks: {
                weekdays: 'WWW',
            },
            attributes: [],
        }
    },

    mounted() {
        this.getItems()
    },

    methods: {
        goTo(customData) {
            this.$store.commit('browsing/SET_YEAR', customData.year)
            this.$store.commit('reportingVM/SET_SEARCH', customData.client_name)
            window.location.href = customData.url
        },

        async getItems() {
            try {
                this.loading = true
                const { year } = this.$refs.vc.pages[0]
                const { month } = this.$refs.vc.pages[0]
                const response = await axios.get(
                    `/reporting/clients/${this.client}/calendar/${year}/${month}`
                )
                const deadlines = response.data.data.deadlines.data
                const todos = response.data.data.todos.data
                this.attributes = deadlines.concat(todos)
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        handleErrors(errorResponse) {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },
    },
}
</script>

<style scoped></style>
